module.exports = __webpack_public_path__ + "56774c04b3440d8cd8f0d30a609229d8.svg";